import { render, staticRenderFns } from "./DescriptionInput.vue?vue&type=template&id=454cc33a"
import script from "./DescriptionInput.vue?vue&type=script&lang=js"
export * from "./DescriptionInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports